import z from "zod";

export const fleetSchema = z.object({
	id: z.number().nullable(),
	description: z.string().min(1).max(255),
});

export const fleetSelectOptionSchema = z.object({
	id: z.number(),
	description: z.string(),
});

export type FleetSchemaInput = z.input<typeof fleetSchema>;
export type FleetSchemaOutput = z.output<typeof fleetSchema>;
